// src/CaptchaScreen.js
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

function CaptchaScreen({ onVerified }) {
  const handleChange = (value) => {
    if (value) {
      onVerified(); // ✅ callback to unlock the site
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.box}>
        <p style={styles.text}>Verifying that you are not a robot...</p>
        <ReCAPTCHA
          sitekey="6Leh2j0rAAAAAGjpcI5NjRcigfAoMboj07RL8UzU"  // 🔁 Replace with your reCAPTCHA v2 checkbox key
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

// 💡 Styles for white screen and centered box
const styles = {
  overlay: {
    backgroundColor: "#fff",
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  box: {
    textAlign: "center",
  },
  text: {
    marginBottom: "20px",
    fontSize: "18px",
  },
};

export default CaptchaScreen;
